<template>
  <div class="subtitle flex between">
    {{ text }}
	<div class="FontSize14 FontGray" v-if="showmore">
		更多>
	</div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    showmore:{
		type:Boolean,
		default:false
	}
  },
};
</script>

<style lang="scss" scope>
  .subtitle {
    
          text-align: left;
          padding-left: 13px;
          font-size: 22px;
          line-height: 22px;
          color: #333333;
          border-left: 4px solid #0465ea;
}
</style>